import { createTheme } from '@material-ui/core';

const theme = createTheme({
  typography: {
    fontFamily:
      'Noto Sans CJK KR, Noto Sans, RobotoDraft, Roboto, San Francisco, Apple SD Gothic Neo, Helvetica Neue, sans-serif',
    textTransform: 'none',
    fontSize: 16,
  },
  font: {
    size8: '0.5rem',
    size10: '.625rem', // "10px"
    size11: '.6875rem', // "11px"
    size12: '.75rem', // "12px"
    size13: '.8125rem', // "13px"
    size13_5: '.84375rem', // "13.5px"
    size14: '.875rem', // "14px"
    size15: '.9375rem', // "15px"
    size16: '1rem', // "16px"
    size17: '1.0625rem', // "17px"
    size18: '1.125rem', // "18px"
    size20: '1.25rem', //1.25rem
    size26: '1.625rem', // "26px"
    size35: '2.188rem',
    font50: '3.125rem', // "50px"
  },
  color: {
    app_bar_title_text: '#262626',
    app_bar_material_background: '#ffffff',

    primary_text_default_dark: '#fff',
    list_divider: '#e1e1e1',
    divider: {
      grey: '#eee',
    },

    accent: '#0A8297', // "#00a0b6",
    text: '#262626',
    title: '#7f7f7f',

    // Old
    lightGrey: '#cdcdcd',
    grey: '#888',
    black: '#343434',
    background: '#f0ece4',
    text_color: {
      red: '#ea1917', //"#da0f47",
      grey: '#666',
      black: '#000',
      price_na: '#aaa',
    },
    message: {
      background: '#ffffff', //"#e4e4e4",//"#7f7f7f", // thinq
      background_white: '#fff',
      color: '#000', // "#262626", //thinq
      date: '#666',
      grey: '#666',
      period: '#008182',
    },
    button: {
      background_white: '#fff',
      background_red: '#ea1917', //"#da0f47",
      background_grey: '#eee',
      background_red_disable: '#999',
      background_white_disable: '#f4f4f4',
      label_sg: '#008182',
      text_white: '#fff',
      text_black: '#222',
      text_grey: '#666',
      text_white_disable: '#bbb',
      text_red_disable: '#999',
      border_disable: '#999',

      rbut_bg: '#ea1917', //"#da0f47",
      rbut_text: '#fff',
      rbut_bg_disable: '#999',
      rbut_text_disable: '#bbb',
      wbut_bg: '#fff',
      wbut_text: '#ea1917', //"#da0f47",
      wbut_border: '#ea1917', //"#da0f47",
      wbut_bg_disable: '#f4f4f4',
      // wbut_text_disable: "#999",
      wbut_text_disable: '#BBBBBB',
      wbut_border_disable: '#999',
    },
    badge: {
      bg_red: '#ffeef3',
      bg_pupple: '#f7f3ff',
      bg_green: '#e5f2f2',
      bg_grey: '#f6f6f6',
      text_red: '#ea1917', //"#da0f47",
      text_pupple: '#6735ea',
      text_green: '#008182',
      text_grey: '#666',
    },
    select: {
      color: '#bf134a',
    },
    input: {
      // text: "rgba(38, 38, 38)",
      text: '#000',
      placeholder: '#666', // "rgba(38, 38, 38, 0.4)",
      disabled: 'rgba(38, 38, 38, 0.5)',
      modal_disable: '#ededed',
    },
    menu: {
      background: '#fff',
      home: '#262626',
      homeSelected: '#ccc',
      item: '#0A8297',
    },
  },
  palette: {
    primary: {
      main: '#0a8297', //"#00a0b6"
    },
    secondary: {
      main: '#e63869',
    },
    tertiary: {
      main: '#35c8e6',
    },
    search: {
      background: '#2d2d2d',
    },
  },
  toggle: {
    thumbOnColor: '#e63869',
    trackOnColor: '#35c8e6',
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        html: {
          font: '-apple-system-body !important',
          fontSize: '16px',
        },
        body: {
          font: '-apple-system-body',
          fontSize: '16px',
        },
      },
    },
  },
});

export default theme;
